// ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  // убеждаемся, что хук вызывается внутри ThemeProvider
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Пытаемся получить тему из localStorage, иначе исползуем 'light' дефолту
  const [theme, setTheme] = useState(() => {
    const localTheme = localStorage.getItem("theme");
    return localTheme || "light";
  });

  useEffect(() => {
    document.body.className = `${theme}-theme`;

    // Сохраняем в локал сториж
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Функция переключения темы
  const toggleTheme = () => {
    // Переключаем с текущей на противоположную
    setTheme((currentTheme) => (currentTheme === "light" ? "dark" : "light"));
  };

  // преедоставляем состояние и функцию через контекст
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
